import React from 'react'
import styled from 'styled-components'
import { EditOutlined, Add } from '@material-ui/icons'

import { Spacings, Text, Devices } from '@styles'

import Button from '../../basic/Button'
import { H4 } from '@base'

export const CardHeaderRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-bottom: ${Spacings.SPACING_1B};
	margin-bottom: ${Spacings.SPACING_1B};
`

export const CardHeaderTitle = styled(H4)`
	font-weight: ${Text.BOLD_600};
	margin: 0;

	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};

	svg {
		color: ${({ theme }) => theme.colors.brand.primary};
		font-size: 1.25em;
	}

	@media ${Devices.tablet} {
		font-size: ${({ size }) => (size === 'large' ? Text.LARGE : Text.MEDIUM)};
	}

	${({ size }) =>
		size === 'large' &&
		`
		svg {
			font-size: ${Text.XX_LARGE};
		}
	`}
`

const CardHeaderV2 = ({ title, icon: Icon, showAction = false, actionLabel, onAction, size, actionVariant = 'link', disabled = false }) => (
	<CardHeaderRow>
		<CardHeaderTitle size={size}>
			{Icon && <Icon />}
			{title}
		</CardHeaderTitle>
		{showAction &&
			(actionVariant === 'solid' ? (
				<Button variant='solid' color='primary' onClick={onAction} disabled={disabled}>
					<Add fontSize='small' />
					{actionLabel}
				</Button>
			) : (
				<Button variant='link' color='primary' onClick={onAction} disabled={disabled}>
					<EditOutlined />
					{actionLabel}
				</Button>
			))}
	</CardHeaderRow>
)

export default CardHeaderV2
